export const LogoMark = ({ className = "h-8 w-8", light = false }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="9" fill={light ? "#F4F2EC" : "#0D0F14"} />
    <path d="M8 12l6 16 6-12 6 12 6-16" fill="none" stroke={light ? "#0D0F14" : "#F4F2EC"} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="16" r="3" fill="#2337FF" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark light={light} />
    <span className={`text-lg font-bold tracking-tight ${light ? "text-[var(--paper)]" : "text-[var(--ink)]"}`}>
      wireaxis<span className="text-[var(--cobalt)]">.</span>
    </span>
  </span>
);
